// extracted by mini-css-extract-plugin
module.exports = {"root":"prompt_root__qO5yT","buttonContainer":"prompt_buttonContainer__DfKEB","buttonCancel":"prompt_buttonCancel__KQ1FT","description":"prompt_description__dBf4V"};